module.exports = __webpack_public_path__ + "static/media/badge-dollar.53928010.svg";